import { render, staticRenderFns } from "./InputDatePicker.vue?vue&type=template&id=56d081e6&scoped=true&"
import script from "./InputDatePicker.vue?vue&type=script&lang=js&"
export * from "./InputDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./InputDatePicker.vue?vue&type=style&index=0&id=56d081e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d081e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VTextField})
